import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { Sxable } from 'library/types';

export const NewBadge = ({
	endDateNewBadge,
	sx = [],
}: { endDateNewBadge?: Date } & Sxable) => {
	const { t } = useTranslation(['common']);

	return (
		endDateNewBadge &&
		new Date() < endDateNewBadge && (
			<Chip
				label={t('common:new')}
				color="secondary"
				size="small"
				sx={[
					{
						height: 20,
						fontSize: '0.75rem',
						textTransform: 'uppercase',
					},
					...(Array.isArray(sx) ? sx : [sx]),
				]}
			/>
		)
	);
};
